import { useEffect, useState } from "react";
import "../../Pages/HomePage.css";
import createIncidentAPI from "../../API/useCreateIncidentAPI";
import useSenapiPumps from "../../API/useSenapiPumps";
import useSenapiVehiclesInfo from "../../API/useSenapiVehiclesInfo";
import useSenapiFuelTypes from "../../API/SenapiFuelTypes";
import useGetEmployees from "../../API/useGetEmployees";
import { DRIVE_OFF } from "../../Constant/constant";
import SimpleBackdrop from "../SimpleBackdrop";
import {  Modal } from "react-bootstrap";
import moment from "moment";
import DateConfirmModal from "./DateConfirmModal";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

const DriveOffModal = ({
  selectedOptions,
  setSelectedEventData,
  show,
  onHide,
  setSuccessDriveOff,
  settitleData,
  setBodyData,
}) => {
  const initialDriveOFFDetails = {
    licencePlateNumber: "",
    colour: "",
    shape: "",
    make: "",
    incidentDate: "",
    fuelType: "",
    fuelCost: "",
    fuelLitres: "",
    reference: "",
    pumpNumber: "",
    note: "",
    employeeName: "",
    type: DRIVE_OFF,
  };
  const [selectedDate, setSelectedDate] = useState(new Date());
  const resetSelectedEventData = () => {
    setSelectedEventData((prevOptions) => {
      const resetOptions = {};
      Object.keys(prevOptions).forEach((key) => {
        resetOptions[key] = "";
      });
      return resetOptions;
    });
  };
  const [showModal, setShowModal] = useState(false);
  const [tempDate, setTempDate] = useState(null); // to hold user-selected date if it's old
  const [loading, setLoading] = useState(false);
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  const customerId = userData ? userData.custID : null;
  const site = userData ? userData.sites[0].name : null;
  const [driveOFFDetails, setDriveOFFDetails] = useState(
    initialDriveOFFDetails
  );
  const { pumpData } = useSenapiPumps();
  const { fuelTypes } = useSenapiFuelTypes(site);
  const { colors, models, shapes } = useSenapiVehiclesInfo(customerId);

  const { employees } = useGetEmployees();
  // Filter employees with active=true
  const activeEmployees = employees.filter(
    (employee) => employee.active === true
  );

  // Function to update driveOFFDetails based on selectedOptions
  const updateDriveOFFDetails = () => {
    if (
      typeof selectedOptions.eventID === "string" &&
      selectedOptions.eventID.trim() === ""
    ) {
      // console.log("EventID is empty string, updating pump number...");
      setDriveOFFDetails((prevDetails) => ({
        ...prevDetails,
        ...(selectedOptions.ocr != null && {
          licencePlateNumber: selectedOptions.ocr,
        }),
        eventID: undefined, // Remove the eventID property,
        pumpNumber: selectedOptions.id,
      }));
    } else {
      // console.log("EventID is not an empty string, updating eventID...");
      setDriveOFFDetails((prevDetails) => ({
        ...prevDetails,
        ...(selectedOptions.ocr != null && {
          licencePlateNumber: selectedOptions.ocr,
        }),
        eventID: selectedOptions.eventID,
        pumpNumber: selectedOptions.id,
      }));
    }
  };

  // Update the licencePlateNumber and eventID fields when selectedOptions changes
  useEffect(() => {
    updateDriveOFFDetails();
    setSelectedDate(new Date());
  }, [selectedOptions]);


  const handleChange = (event) => {
    const { name, value } = event.target;

    const generalValidationPattern = /^[A-Za-z0-9\s]*$/;
    const decimalValidationPattern = /^\d{0,10}(\.\d{0,2})?$/;
    const removeLeadingZeros = (val) => {
      // If value starts with leading zeros followed by a digit, remove leading zeros
      return val.replace(/^0+(\d)/, "$1");
    };
    if (name === "fuelCost" || name === "fuelLitres") {
      if (decimalValidationPattern.test(value)) {
        const sanitizedValue = removeLeadingZeros(value);
        setDriveOFFDetails({ ...driveOFFDetails, [name]: sanitizedValue });
      }
    } else if (name === "licencePlateNumber" || name === "reference") {
      const trimmedValue = value.replace(/\s/g, "");
      const uppercaseValue = trimmedValue.toUpperCase();
      const isValidInput = generalValidationPattern.test(uppercaseValue);
      const isLessThanTenChars =
        name === "licencePlateNumber" ? uppercaseValue.length <= 10 : true;
      const isLessThanFifteenChars =
        name === "reference" ? uppercaseValue.length <= 15 : true;

      if (
        (isValidInput && isLessThanTenChars && isLessThanFifteenChars) ||
        uppercaseValue === ""
      ) {
        setDriveOFFDetails({ ...driveOFFDetails, [name]: uppercaseValue });
      }
    } else {
      setDriveOFFDetails({ ...driveOFFDetails, [name]: value });
    }

    checkLabelErrorOnChange(name, value);
  };
  const handleBlur = (event) => {
    const { name, value } = event.target;

    if (
      (name === "fuelCost" || name === "fuelLitres") &&
      parseFloat(value) <= 0
    ) {
      setDriveOFFDetails({ ...driveOFFDetails, [name]: "" });
      // console.log(`${name} must be greater than 0.`);
    }
  };
  const checkLabelErrorOnChange = (name, value) => {
    if (value.trim() !== "") {
      setLabelError("");
    }
  };

  const formatDateTimeLocal = (date) => {
    const pad = (n) => (n < 10 ? "0" + n : n);
    // Format for input field (no seconds)
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };


  const handleDateChange = (event) => {
    const value = event.target.value;
    const parsedDate = new Date(value);

    if (isNaN(parsedDate)) return;

    const now = new Date();
    const min = new Date();
    min.setDate(now.getDate() - 15);

    if (parsedDate < min) {
      setTempDate(parsedDate);        // store selected date temporarily
      setShowModal(true);             // show confirmation modal
    } else if (parsedDate > now) {
      alert("Please select a date within the last 15 days.");
      const fallback = formatDateTimeLocal(now);
      setSelectedDate(now);
      event.target.value = fallback;
    } else {
      setSelectedDate(parsedDate);    // valid recent date
    }
  };



  const currentDateTime = new Date();
  const minDateTime = new Date();
  minDateTime.setDate(currentDateTime.getDate() - 14);


  const handleSubmit = async (e) => {
    if (isValid(currentPage)) {
      e.preventDefault();
      setLoading(true);
      setSuccessDriveOff(false);
      // Check if all mandatory fields are filled
      try {
        const utcTime = moment.utc(selectedDate);
        const localTime = utcTime.local();
        const fullFormatted = localTime.format("YYYY-MM-DDTHH:mm:ss.SSS"); // Keep full precision here ✅
        const trimmedNote = driveOFFDetails.note.trim();

        let driveOFFDetailsWithDate = {
          ...driveOFFDetails,
          incidentDate: fullFormatted,
        };;

        // Include note in driveOFFDetailsWithDate if it's not empty
        if (trimmedNote !== "") {
          driveOFFDetailsWithDate = {
            ...driveOFFDetailsWithDate,
            note: trimmedNote,
          };
        } else {
          // console.log("Note is empty, removing it from state.");
          // Remove note from driveOFFDetailsWithDate if it's empty
          const { note, ...remainingDetails } = driveOFFDetailsWithDate;
          driveOFFDetailsWithDate = remainingDetails;
        }
        const result = await createIncidentAPI(driveOFFDetailsWithDate);

        setLoading(false);

        if (result.success) {
          closeModal();
          setSuccessDriveOff(true);
          settitleData("Incident submitted!");
          setBodyData("The incident has been successfully submitted.");
          setDriveOFFDetails(initialDriveOFFDetails);
        } else {
          setSuccessDriveOff(false);

          // Show error toast
          NotificationManager.error(
            <div className="showNormalFont">
              {result.isDuplicate
                ? "⚠️ Duplicate Incident Detected: An incident with the same offense type, pump, and site has already been recorded within the last 10 minutes. A new incident cannot be created."
                : "IOU creation failed. Please try again later"}
            </div>,
            <div className="showNormalFont">Error</div>
          );

          // Keep modal open for user to fix issues (do NOT closeModal)
        }
      } catch (error) {
        setLoading(false);
        setSuccessDriveOff(false);

        NotificationManager.error(
          <div className="showNormalFont">
            {error.message || "IOU creation failed. Please try again later"}
          </div>,
          <div className="showNormalFont">Error</div>
        );

        // Keep modal open on error (do NOT closeModal)
      }
    }
  };

  const closeModal = () => {
    setCurrentPage(1);
    setRequiredError(false);
    setLabelError("");
    onHide();
    updateDriveOFFDetails();
    setSelectedDate(new Date());
    setDriveOFFDetails(initialDriveOFFDetails);
    resetSelectedEventData();
  };

  useEffect(() => {
    if (show) {
      setSelectedDate(new Date()); // Set the selectedDate to the current date when the modal is opened
    }
  }, [show]);

  const [currentPage, setCurrentPage] = useState(1);
  const [isRequiredError, setRequiredError] = useState(false);
  const [labelError, setLabelError] = useState("");

  const isValid = (page) => {
    switch (page) {
      case 1:
        if (!driveOFFDetails.licencePlateNumber || !driveOFFDetails.licencePlateNumber.trim()) {
          setLabelError("licencePlateNumber");
          setRequiredError(true);
          return false;
        }
        if (!driveOFFDetails.colour || !driveOFFDetails.colour.trim()) {
          setLabelError("colour");
          setRequiredError(true);
          return false;
        }
        if (!driveOFFDetails.shape || !driveOFFDetails.shape.trim()) {
          setLabelError("shape");
          setRequiredError(true);
          return false;
        }
        if (!driveOFFDetails.make || !driveOFFDetails.make.trim()) {
          setLabelError("make");
          setRequiredError(true);
          return false;
        } else {
          setLabelError("");
          return true;
        }
      case 2:
        if (!driveOFFDetails.fuelType || !driveOFFDetails.fuelType.trim()) {
          setLabelError("fuelType");
          setRequiredError(true);
          return false;
        }

        if (!driveOFFDetails.fuelCost || !driveOFFDetails.fuelCost.trim()) {
          setLabelError("fuelCost");
          setRequiredError(true);
          return false;
        }

        if (!driveOFFDetails.fuelLitres || !driveOFFDetails.fuelLitres.trim()) {
          setLabelError("fuelLitres");
          setRequiredError(true);
          return false;
        }

        // if (!driveOFFDetails.reference || !driveOFFDetails.reference.trim()) {
        //   setLabelError("reference");
        //   setRequiredError(true);
        //   return false;
        // }

        if (
          isNaN(driveOFFDetails.pumpNumber) ||
          driveOFFDetails.pumpNumber === null ||
          driveOFFDetails.pumpNumber === "" ||
          driveOFFDetails.pumpNumber === undefined
        ) {
          setLabelError("pumpNumber");
          setRequiredError(true);
          return false;
        } else {
          setLabelError("");
          return true;
        }

      case 3:
        if (!driveOFFDetails.note || !driveOFFDetails.note.trim()) {
          setLabelError("note");
          setRequiredError(true);
          return false;
        }
        if (
          !driveOFFDetails.employeeName || !driveOFFDetails.employeeName.trim()
        ) {
          setLabelError("employeeName");
          setRequiredError(true);
          return false;
        } else {
          setLabelError("");
          return true;
        }
      default:
        return true;
    }
  };
  const nextPage = () => {
    if (isValid(currentPage)) {
      setRequiredError(false);
      setCurrentPage((prevPage) => (prevPage < 3 ? prevPage + 1 : prevPage));
    }
  };

  const prevPage = () => {
    if (currentPage === 1) {
      closeModal();
    }
    setCurrentPage((prevPage) => (prevPage > 1 ? prevPage - 1 : prevPage));
  };

  return (
    <Modal show={show} onHide={onHide} fullscreen>
      <NotificationContainer />

      <SimpleBackdrop open={loading} onClose={() => setLoading(false)} />
      <div className="modal-dialog modal-dialog-centered modal-fullscreen modal-dialog-scrollable">
        <div
          className="modal-content"
          style={{ backgroundColor: "#212529", color: "#FFFFFF" }}
        >
          <div className="modal-header">
            <h5 id="DriveOff-title">LOG DRIVE OFF INCIDENT</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body">
            <div
              className="container-fluid showNormalFont"
              style={{ marginLeft: "-5px" }}
            >
              <form onSubmit={handleSubmit}>
                {/*  firsy section of  vehicle details*/}
                {currentPage === 1 && (
                  <div className="container-fluid">
                    <h5 style={{ color: "#fff" }}>Vehicle Details</h5>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col">
                            {/* Content for the Licence Plate */}
                            <div className="pt-2 pb-4">
                              <label
                                className={`${labelError === "licencePlateNumber"
                                  ? "text-danger"
                                  : ""
                                  }`}
                                style={{
                                  margin: "0px 0px 8px",
                                  color: "#adb5bd",
                                }}
                              >
                                Licence Plate Number
                              </label>
                              <br />
                              <input
                                type="text"
                                autoComplete="off"
                                name="licencePlateNumber"
                                value={driveOFFDetails.licencePlateNumber || ""}
                                maxLength={10}
                                onChange={handleChange}
                                className="col-12"
                                autoFocus
                                // placeholder="Enter Licence Plate Number"
                                style={{
                                  backgroundColor: "#212529",
                                  color: "#ADB5BD",
                                  borderColor: "#495057",
                                  border: "1px solid #495057",
                                  height: "2.3rem",
                                  padding: "6px 12px",
                                }}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col">
                            {/* Content for the Colour */}
                            <div className="pt-2 pb-4">
                              <label
                                className={`${labelError === "colour" ? "text-danger" : ""
                                  }`}
                                style={{
                                  margin: "0px 0px 8px",
                                  color: "#adb5bd",
                                }}
                              >
                                Colour
                              </label>
                              <br />
                              <select
                                name="colour"
                                value={driveOFFDetails.colour || ""}
                                onChange={handleChange}
                                className="col-12"
                                style={{
                                  height: "2.3rem",
                                  backgroundColor: "#212529",
                                  color: "#ADB5BD",
                                  borderColor: "#495057",
                                  border: "1px solid #495057",
                                  padding: "6px 36px 6px 12px",
                                }}
                                required
                              >
                                <option value=""></option>
                                {colors.map((color) => (
                                  <option key={color} value={color}>
                                    {color}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            {/*Content for the Shape */}
                            <div className="pb-4">
                              <label
                                className={`${labelError === "shape" ? "text-danger" : ""
                                  }`}
                                style={{
                                  margin: "0px 0px 8px",
                                  color: "#adb5bd",
                                }}
                              >
                                Shape
                              </label>
                              <br />
                              <select
                                name="shape"
                                value={driveOFFDetails.shape || ""}
                                onChange={handleChange}
                                className="col-12"
                                style={{
                                  height: "2.3rem",
                                  backgroundColor: "#212529",
                                  color: "#ADB5BD",
                                  borderColor: "#495057",
                                  border: "1px solid #495057",
                                  padding: "6px 36px 6px 12px",
                                }}
                                required
                              >
                                <option value=""></option>
                                {shapes.map((shape) => (
                                  <option key={shape} value={shape}>
                                    {shape}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            {/* Content for the Make */}
                            <div className=" pb-4">
                              <label
                                className={`${labelError === "make" ? "text-danger" : ""
                                  }`}
                                style={{
                                  margin: "0px 0px 8px",
                                  color: "#adb5bd",
                                }}
                              >
                                Make
                              </label>
                              <br />
                              <select
                                style={{
                                  height: "2.3rem",
                                  backgroundColor: "#212529",
                                  color: "#ADB5BD",
                                  borderColor: "#495057",
                                  border: "1px solid #495057",
                                  padding: "6px 36px 6px 12px",
                                }}
                                name="make"
                                value={driveOFFDetails.make || ""}
                                onChange={handleChange}
                                className="col-12"
                                required
                              >
                                <option value=""></option>
                                {models.map((model) => (
                                  <option key={model} value={model}>
                                    {model}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* second section */}
                {currentPage === 2 && (
                  <div className="container-fluid">
                    <h5 style={{ color: "#fff" }}>Fuel Details</h5>
                    <div className="row">
                      <div className="col-12">
                        <div className="row">
                          <div className="col">
                            {/* Content for the Fuel type */}
                            <div className="pt-2 pb-4">
                              <label
                                style={{
                                  margin: "0px 0px 8px",
                                  color: "#adb5bd",
                                }}
                              >
                                When did the incident occur
                              </label>
                              <br />
                              <div
                                style={{
                                  border: "1px solid rgb(73, 80, 87)",
                                  width: "100%",
                                  backgroundColor: "#212529",
                                }}
                              >
                                <input
                                  type="datetime-local"
                                  autoFocus
                                  value={formatDateTimeLocal(selectedDate)}
                                  onChange={handleDateChange}
                                  name="paymentDate"
                                  className="custom-date-picker"
                                  id="paymentDate"
                                  style={{
                                    width: "100%",
                                    height: "35px",
                                    backgroundColor: "#212529",
                                    color: "#ADB5BD",
                                    border: "none",
                                    boxSizing: "border-box",
                                    padding: "6px 12px",
                                  }}
                                  min={formatDateTimeLocal(minDateTime)}
                                  max={formatDateTimeLocal(currentDateTime)}
                                />

                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            {/* Content for the Fuel type */}
                            <div className="pt-2 pb-4">
                              <label
                                className={`${labelError === "fuelType" ? "text-danger" : ""
                                  }`}
                                style={{
                                  margin: "0px 0px 8px",
                                  color: "#adb5bd",
                                }}
                              >
                                Fuel Type
                              </label>
                              <br />
                              <select
                                style={{
                                  height: "2.3rem",
                                  backgroundColor: "#212529",
                                  color: "#ADB5BD",
                                  borderColor: "#ADB5BD",
                                  border: "1px solid #495057",
                                  padding: "6px 12px",
                                }}
                                name="fuelType"
                                value={driveOFFDetails.fuelType || ""}
                                onChange={handleChange}
                                className="col-12 form-select"
                                required
                              >
                                <option value=""></option>
                                {fuelTypes &&
                                  fuelTypes.map((fuelType, index) => (
                                    <option key={index} value={fuelType}>
                                      {fuelType}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            {/* Content for the fuel cost */}
                            <div className="pb-4">
                              <label
                                className={`${labelError === "fuelCost" ? "text-danger" : ""
                                  }`}
                                style={{
                                  margin: "0px 0px 8px",
                                  color: "#adb5bd",
                                }}
                              >
                                Fuel Cost
                              </label>
                              <br />
                              <input
                                type="text"
                                autoComplete="off"
                                step="any"
                                name="fuelCost"
                                onBlur={handleBlur}
                                value={driveOFFDetails.fuelCost || ""}
                                onChange={(e) => {
                                  const newValue = e.target.value
                                    .replace(/[^0-9.]/g, "")
                                    .replace(/^0+(?=\d)/g, "")
                                    .replace(/\.(?=.*\.)/g, "");// Allow only digits and dot, handle leading zeros
                                  handleChange({
                                    target: {
                                      name: "fuelCost",
                                      value: newValue,
                                    },
                                  });
                                }}
                                style={{
                                  backgroundColor: "#212529",
                                  color: "#ADB5BD",
                                  borderColor: "#ADB5BD",
                                  border: "1px solid #495057",
                                  height: "2.3rem",
                                  padding: "6px 12px",
                                }}
                                className="col-12"
                                // placeholder="Enter fuel cost"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col">
                            {/* Content for the Litres of Fuel */}
                            <div className="pb-4">
                              <label
                                className={`${labelError === "fuelLitres"
                                  ? "text-danger"
                                  : ""
                                  }`}
                                style={{
                                  margin: "0px 0px 8px",
                                  color: "#adb5bd",
                                }}
                              >
                                Litres of Fuel
                              </label>
                              <br />
                              <input
                                type="text"
                                step="any"
                                name="fuelLitres"
                                autoComplete="off"
                                onBlur={handleBlur}
                                value={driveOFFDetails.fuelLitres || ""}
                                onChange={(e) => {
                                  const newValue = e.target.value
                                    .replace(/[^0-9.]/g, "")
                                    .replace(/^0+(?=\d)/g, "")
                                    .replace(/\.(?=.*\.)/g, ""); // Allow only digits and dot, handle leading zeros
                                  handleChange({
                                    target: {
                                      name: "fuelLitres",
                                      value: newValue,
                                    },
                                  });
                                }}
                                style={{
                                  backgroundColor: "#212529",
                                  color: "#ADB5BD",
                                  borderColor: "#ADB5BD",
                                  border: "1px solid #495057",
                                  height: "2.3rem",
                                  padding: "6px 12px",
                                }}
                                className="col-12"
                                // placeholder="Enter litres of fuel"
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col">
                            {/* Content for the Reference */}
                            <div className="pb-4">
                              <label
                                className={`${labelError === "reference"
                                  ? "text-danger"
                                  : ""
                                  }`}
                                style={{
                                  margin: "0px 0px 8px",
                                  color: "#adb5bd",
                                }}
                              >
                                Reference
                              </label>
                              <br />
                              <input
                                type="text"
                                name="reference"
                                autoComplete="off"
                                maxLength={15}
                                value={driveOFFDetails.reference || ""}
                                onChange={(e) => {
                                  handleChange({
                                    target: {
                                      name: "reference",
                                      value: e.target.value,
                                    },
                                  });
                                }}
                                style={{
                                  backgroundColor: "#212529",
                                  color: "#ADB5BD",
                                  borderColor: "#ADB5BD",
                                  border: "1px solid #495057",
                                  height: "2.3rem",
                                  padding: "6px 12px",
                                }}
                                className="col-12"
                              // placeholder="Enter reference number"
                              />
                              <small style={{ color: "#ADB5BD" }}>
                                Receipt number or reference from POS
                              </small>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            {/* Content for the Pump Number */}
                            <div className="pb-4">
                              <label
                                className={`${labelError === "pumpNumber"
                                  ? "text-danger"
                                  : ""
                                  }`}
                                style={{
                                  margin: "0px 0px 8px",
                                  color: "#adb5bd",
                                }}
                              >
                                Pump Number
                              </label>
                              <br />
                              <select
                                style={{
                                  height: "2.3rem",
                                  backgroundColor: "#212529",
                                  color: "#ADB5BD",
                                  borderColor: "#495057",
                                  border: "1px solid #495057",
                                  padding: "6px 12px",
                                }}
                                name="pumpNumber"
                                value={driveOFFDetails.pumpNumber || ""}
                                onChange={handleChange}
                                className="col-12"
                                required
                              >
                                <option value=""></option>
                                {pumpData.map((pump) => (
                                  <option key={pump.number} value={pump.number}>
                                    {pump.number}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* third section */}
                {currentPage === 3 && (
                  <>
                    <div className="container-fluid">
                      <h5 style={{ color: "#fff" }}>Drive Off Details</h5>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col">
                              {/* Content for the Comments */}
                              <div className="pb-2">
                                <label
                                  className={`${labelError === "note" ? "text-danger" : ""
                                    }`}
                                  style={{
                                    margin: "0px 0px 8px",
                                    color: "#adb5bd",
                                  }}
                                >
                                  Comments
                                </label>
                                <br />
                                <textarea
                                  type="text"
                                  autoFocus
                                  autoComplete="off"
                                  style={{
                                    backgroundColor: "#212529",
                                    color: "#ADB5BD",
                                    borderColor: "#495057",
                                    border: "1px solid #495057",
                                    height: "6.3rem",
                                    padding: "6px 12px",
                                  }}
                                  name="note"
                                  value={driveOFFDetails.note || ""}
                                  onChange={handleChange}
                                  className="col-12"
                                  maxLength={200}
                                // placeholder="Please provide a comment or note pertaining to the incident."
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col">
                              {/* Content for the Employee */}
                              <div className="pb-4">
                                <label
                                  className={`${labelError === "employeeName"
                                    ? "text-danger"
                                    : ""
                                    }`}
                                  style={{
                                    margin: "0px 0px 8px",
                                    color: "#adb5bd",
                                  }}
                                >
                                  Employee
                                </label>
                                <br />
                                <select
                                  style={{
                                    height: "2.3rem",
                                    backgroundColor: "#212529",
                                    color: "#ADB5BD",
                                    borderColor: "#495057",
                                    border: "1px solid #495057",
                                    padding: "6px 12px",
                                  }}
                                  name="employeeName"
                                  value={driveOFFDetails.employeeName || ""}
                                  onChange={handleChange}
                                  className="col-12"
                                  required
                                >
                                  <option value=""></option>
                                  {activeEmployees.map((employee, index) => (
                                    <option key={index} value={employee.name}>
                                      {employee.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="container-fluid"
                      style={{ marginLeft: "-5px" }}
                    >
                      {/* Declaration */}
                      <h5 style={{ color: "#fff" }}>Declaration</h5>
                      <div className="row" style={{ color: "#ADB5BD" }}>
                        <div className="col-12 pt-1">
                          The
                          <span style={{ fontWeight: "bold",marginLeft:'5px',marginRight:'5px' }}>employee</span>
                          agrees to the below terms:
                        </div>
                        <div className="col-12 pt-4 pb-4">
                          By submitting this report, I declare the details to be
                          true to the best of my knowledge. I understand that a
                          person who intentionally makes a false statement in a
                          statutory declaration is guilty of an offence under
                          section 11 of the Statutory Declarations Act 1959, and
                          I believe that the statements in this declaration are
                          true in every particular.
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </form>
            </div>
          </div>
          <div className="modal-footer d-flex showNormalFont">
            <div className="text-danger ">
              {isRequiredError
                ? "Please answer all questions on the page before proceeding"
                : ""}
            </div>
            <button
              className="btn btn-secondary me-2 w-25 custom-btn"
              onClick={closeModal}
            >
              Close
            </button>
            <button
              className="btn btn-primary me-2 w-25 custom-btn"
              onClick={prevPage}
            >
              Back
            </button>
            {currentPage < 3 ? (
              <button
                className="btn btn-primary w-25 custom-btn"
                onClick={nextPage}
              >
                Next
              </button>
            ) : (
              <button
                className="btn btn-primary w-25 custom-btn"
                onClick={handleSubmit}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
      <DateConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        setSelectedDate={setSelectedDate}
        tempDate={tempDate} />
    </Modal>
  );
};

export default DriveOffModal;
